import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=4f38382c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f38382c"]])

export default __exports__